import { nsform } from '@isyc-react/form/i18n/namespaces';
export const preloadNamespaces = [
    nsform.common,
];
